import {
  useContext,
  useMemo,
  Fragment,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { Typography } from '@mui/material';
import { LocalAirport } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Flight, Filter } from 'components';
import { FlightStatusContext } from 'context';
import {
  Container,
  HeadWrapper,
  Heading,
  FlightsCount,
  Points,
  Destination,
  Date,
  FilterWrapper,
  ListWrapper,
  Code,
} from './ResultsWrapper.style';

const ResultsWrapper = ({ isSearch: { arrival, departure, number } }) => {
  const { t, i18n } = useTranslation();
  const { translation: english } = i18n.getDataByLanguage('en');
  const {
    state: {
      flights,
      flightsFilter,
      searchedArrival,
      searchedDeparture,
      searchedDate,
    },
  } = useContext(FlightStatusContext);
  const [list, setList] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const filteredFlights = useMemo(() => {
    if (flightsFilter === 'flightsstatus.results.status.any')
      return flights?.flightStatuses;
    else
      return flights?.flightStatuses?.filter((el) =>
        el?.statusInfo?.status
          ?.toLowerCase()
          ?.includes(english[flightsFilter]?.toLowerCase().split(' ')[0])
      );
  }, [flights, flightsFilter, english]);

  const getMoreFlights = useCallback(() => {
    if (list?.length < filteredFlights?.length) {
      setList((prev) => [
        ...prev,
        ...filteredFlights.slice(list.length, 20 + list.length),
      ]);
    } else {
      setHasMore(false);
    }
  }, [list, filteredFlights]);

  useEffect(() => {
    setList([]);
    setHasMore(true);
    if (filteredFlights && filteredFlights.length > 0)
      setList([...filteredFlights.slice(0, 20)]);
  }, [filteredFlights]);

  return (
    <Container>
      <HeadWrapper>
        <Heading variant="h5" color="primary">
          {t('flightstatus.results.h1.')}
        </Heading>
        <FlightsCount style={{ fontSize: '18px' }} variant="p">{`(${
          filteredFlights?.length || 0
        } ${t('flightstatus.results.counts')})`}</FlightsCount>
      </HeadWrapper>
      {flights?.status !== 404 && (
        <Fragment>
          <Points>
            <Destination>
              <Typography variant="p" style={{ fontSize: '24px' }}>
                {departure || number
                  ? searchedDeparture?.city_name
                  : t('flightstatus.search.nocity')}
              </Typography>
              <Code variant="h6" style={{ fontSize: '24px' }}>
                {departure || number ? searchedDeparture?.airport_code : ''}
              </Code>
            </Destination>
            <LocalAirport
              style={{ transform: 'rotate(90deg)', marginRight: '5px' }}
            />
            <Destination>
              <Typography variant="p" style={{ fontSize: '24px' }}>
                {arrival || number
                  ? searchedArrival?.city_name
                  : t('flightstatus.search.nocity')}
              </Typography>
              <Code variant="h6" style={{ fontSize: '24px' }}>
                {arrival || number ? searchedArrival?.airport_code : ''}
              </Code>
            </Destination>
            <Date
              anywhere={!departure && !arrival && !number ? 'true' : ''}
              variant="p"
            >
              {searchedDate}
            </Date>
          </Points>
          <FilterWrapper>
            <Filter />
          </FilterWrapper>
        </Fragment>
      )}
      <ListWrapper elevation={0}>
        {list?.length > 0 ? (
          <InfiniteScroll
            dataLength={list?.length}
            next={getMoreFlights}
            hasMore={hasMore}
          >
            {list?.map((el) => (
              <Flight key={el.flightId} id={el.flightId} flight={el} />
            ))}
          </InfiniteScroll>
        ) : (
          t('flightstatus.results.noflights')
        )}
      </ListWrapper>
    </Container>
  );
};

export default ResultsWrapper;
